import axios, {BASE_API_URL} from "../config/axios";

export const getSellers = async (ids) => {
  try {
    return await axios.get(`/sellers/${ids}`)
  } catch (error) {
    console.error(error)
  }
}